import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateCasinoConfig,
  UpdateCasinoConfigParams,
  CasinoConfigValue,
} from "@/api/casinoConfig";
import { CasinoConfigQueryKeys } from "@/tanstackQuery/queries/casinoConfig";

// Saves the dirty fields one PUT at a time, in field order (the proxy takes
// one category/key pair per request; a rejected pair stops the loop there),
// then refreshes the config ONCE, on success and on error alike. The refresh
// promise is RETURNED from onSettled on purpose: TanStack awaits it before
// the caller's mutate(vars, { onSuccess, onError }) callbacks run, so a toast
// placed there fires after the refetch and a failed save leaves the
// re-fetched values on screen.
export const useUpdateCasinoConfigBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updates: UpdateCasinoConfigParams[]) => {
      const saved: CasinoConfigValue[] = [];
      for (const update of updates) {
        saved.push(await updateCasinoConfig(update));
      }
      return saved;
    },
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: [CasinoConfigQueryKeys.CasinoConfig],
      }),
  });
};
